import { getTimeHr, getTimeDifference } from "helpers/parseDates";
import {
  SHIPPER_TRUCK_PORTABLE,
  SHIPPER_TRUCK_STACIONARY,
} from "./MapPageTypes";

export const configUnitTitle = {
  title: "",
  field: "number",
  rows: [],
};
export const configUnit = {
  title: "",
  field: "number",
  rows: [
    {
      text: "Chofer: ",
      field: "driver",
    },
    {
      text: "Ayudante: ",
      field: "helper",
    },
    {
      text: "Segundo ayudante: ",
      field: "secondHelper",
    },
    {
      text: "Pedidos: ",
      field: "services",
    },
    {
      text: "Venta: ",
      field: "notes",
    },
    {
      text: "Capacidad: ",
      field: "capacity",
      afterText: "Lts.",
    },
    {
      text: "UP: ",
      field: "UP",
    },
  ],
};
export const configService = {
  title: "Pedido: ",
  field: "folio",
  rows: [
    {
      text: "Hora registro: ",
      field: "",
      isFunction: true,
      fn: getTimeHr,
      params: ["hour"],
    },
    {
      text: "Hora actual: ",
      field: "",
      isClock: true,
    },
    {
      text: "Diferencia: ",
      field: "",
      isFunction: true,
      fn: getTimeDifference,
      params: ["hour"],
      hasFormat: true,
      hasClock: true,
      formatParams: "HH:mm:ss",
      propsParams: ["clock"],
      formatPropsParams: "HH:mm",
    },
    {
      text: "Cuenta: ",
      field: "account",
    },
    {
      text: "Cantidad: ",
      field: "quantity",
    },
  ],
};
export const configNote = {
  title: "Servicio: ",
  field: "folio",
  rows: [
    {
      text: "Hora registro: ",
      field: "a_hour",
    },
    {
      text: "Hora surtido: ",
      field: "",
      isFunction: true,
      fn: getTimeHr,
      params: ["hour"],
    },
    {
      text: "Diferencia: ",
      field: "",
      isFunction: true,
      fn: getTimeDifference,
      params: ["a_hour"],
      hasFormat: true,
      formatParams: "HH:mm",
      propsParams: ["hour"],
      formatPropsParams: "HH:mm:ss",
    },
    {
      text: "Cuenta: ",
      field: "account",
    },
    {
      text: "Cantidad: ",
      field: "quantity",
    },
  ],
};
export const unitTypesOptions = [
  { value: 1, label: SHIPPER_TRUCK_STACIONARY },
  { value: 2, label: SHIPPER_TRUCK_PORTABLE },
];
